export default __webpack_public_path__ + "static/media/Tube-assembly-tee-Edit-1.fcb17703.jpg";